import Config from './Config';
/**
 * Capture the `pid` query param a communication link click can carry (see
 * core-api's communications/link-rewriter.ts, which appends it to the
 * destination url before signing the click-tracking token) and hand its raw
 * ciphertext to `send`. The browser never decrypts it — core-input does, on
 * the resulting `externalid` event (see Tracker.trackEncryptedExternalId) —
 * so it just forwards the opaque value as-is.
 *
 * The query param is stripped from the visible URL right away regardless of
 * whether it was captured, same privacy hygiene as the `bid` query param in
 * Device.ts, so the ciphertext doesn't linger in the address bar / history
 * longer than the single page load that carried it.
 */
export function capturePid(send) {
    var urlParams = new URLSearchParams(window.location.search);
    var pid = urlParams.get(Config.QUERY_PARAM_PID);
    if (!pid)
        return;
    urlParams.delete(Config.QUERY_PARAM_PID);
    var query = urlParams.toString();
    window.history.replaceState({}, document.title, window.location.pathname + (query ? '?' + query : ''));
    send(pid);
}
